'use client'

import { Alert as MuiAlert, AlertProps as MuiAlertProps } from '@mui/material'
import { clsx } from 'clsx'

import styles from './alert.module.css'

export type AlertProps = MuiAlertProps
export const Alert = ({ className, ...props }: AlertProps) => (
  <MuiAlert className={clsx(styles.alert, className)} {...props} />
)
